// libs
import { useState, useEffect } from "react";

// components
import CustomButton from "../CustomButton";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import CustomInput from "../CustomInput";

// custom hooks
import useProducts from "../../hooks/useProducts";
import useToken from "../../hooks/useToken";
import useActions from "../../hooks/useActions";
import useAlert from "../../hooks/useAlert";
import useAppData from "../../hooks/useAppData";

// utils
import API from "../../utils/api";

// constants
import actionsTypes from "../../constants/actionsTypes";

// styles
import classes from "./styles.module.css";

export default function ActionsPanel() {
  const { products, editProduct, fetchProducts } = useProducts();
  const [product, setProduct] = useState(null);
  const [productInd, setProductInd] = useState(-1);
  const [token] = useToken();
  const [type, setType] = useState("sell");
  const [price, setPrice] = useState("");
  const [count, setCount] = useState("");
  const { newAction } = useActions();
  const { createAlert } = useAlert();
  const [isPending, setIsPending] = useState(false);
  const { updateBalance } = useAppData();

  const isProduct = type === "purchase" || type === "sell";

  const onProductSelect = (ind) => {
    if (ind < 0) {
      setProduct(null);
      setProductInd(-1);
    } else {
      const product = products[ind];
      setProduct(product);
      setProductInd(ind);
      setPrice(
        type === "purchase" ? product.purchase_price : product.selling_price,
      );
    }
  };

  const onTypeSelect = (type) => {
    setType(type);
    if (product) {
      setPrice(
        type === "purchase" ? product.purchase_price : product.selling_price,
      );
    }
  };

  useEffect(() => {
    if (token === null || products.length > 0) return;
    fetchProducts(token);
  }, [token]);

  const onAddNewAction = () => {
    if (isPending) return;

    setIsPending(true);

    const data = {
      type,
      title: product?.title,
      price: price,
      count,
    };

    if (type === "investment") {
      data.title = "Ввод капитала";
      data.count = 1;
      updateBalance(data.price);
    }

    if (type === "conclusion") {
      data.title = "Вывод капитала";
      data.count = 1;
      updateBalance(data.price * -1);
    }

    API.postToken("/actions/create", data, token).then((d) => {
      setIsPending(false);

      if (d?.status === 200) {
        newAction({
          ...data,
          id: d?.data?.actionId,
          created_at: new Date().toString(),
        });

        createAlert.success("Сделка создана");

        if (type === "purchase") {
          const editedProduct = { ...product, count: +product.count + +count };
          editProduct(product.id, editedProduct);
          setProduct(editedProduct);
          updateBalance(data.price * data.count * -1);
        } else if (type === "sell") {
          const editedProduct = { ...product, count: +product.count - +count };
          editProduct(product.id, editedProduct);
          setProduct(editedProduct);
          updateBalance(data.price * data.count);
        }
      } else {
        if (d?.data) {
          createAlert.error(d?.data?.message ?? "Ошибка сделки");
        }
      }
    });
  };

  return (
    <div className={classes.root}>
      <p className={classes.sectionName}>Категория торгового действия</p>
      <div className={classes.categories}>
        {actionsTypes.map((actionType, ind) => (
          <CustomButton
            key={ind}
            onClick={() => onTypeSelect(actionType.value)}
            className={`${classes.category} ${type === actionType.value && classes.categoryActive}`}
          >
            <actionType.icon size={14} stroke={actionType.iconColor} />
            {actionType.title}
          </CustomButton>
        ))}
      </div>

      <p className={classes.sectionName}>
        {isProduct ? "товар для операции" : "сумма для трансфера капитала"}
      </p>
      {isProduct ? (
        <div>
          <div className={classes.inputs}>
            <CustomDropDown
              value={productInd}
              list={products}
              onSelect={onProductSelect}
            />
            <CustomInput
              className={classes.input}
              value={price}
              setValue={setPrice}
              defaultPlaceholder="Цена"
            />

            <CustomInput
              className={classes.input}
              value={count}
              setValue={setCount}
              defaultPlaceholder="Количество (шт)"
            />
          </div>

          <p className={classes.sectionName}>общий чек</p>
          <div className={classes.summary}>{product ? count * price : 0} ֏</div>
        </div>
      ) : (
        <div>
          <CustomInput
            className={classes.input}
            value={price}
            setValue={setPrice}
            defaultPlaceholder="Сумма"
          />
        </div>
      )}

      <CustomButton
        text="оформить сделку"
        className={classes.submitButton}
        disabled={isPending}
        onClick={onAddNewAction}
      />
    </div>
  );
}
